import React from 'react';
import logo from '../../assets/RRHouseLogoCircle.svg'
import background from '../../assets/dark-bg.jpg';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress'


const styles = theme => ({

    loginDiv: {
        marginTop: "70px",
        marginLeft: "35px",
        marginRight: "35px",
    },
    loginBackground:{
        background: "#ffffff",
        width: "33%",
        height: "100%",
        minHeight: "100vh",
        float: "right",
        minWidth: "320px",
        maxWidth: '500px',
    },
    logoDiv: {
        position: 'fixed', 
        top: 0,
        right: "33%", 
        bottom: 0, 
        left: 0,
        backgroundAttachment: 'fixed',
    },
    logo: {
        background: 'url(' + logo + ')',
        width: "100px",
        height: "100px",
        backgroundSize: 'cover',
       
        margin: "auto",
        position: "absolute",
        top: "0", 
        left: "0",
        bottom: "0", 
        right: "0",
        
    },
    background: {
        backgroundImage: "url(" + background + ")",
        backgroundSize: 'cover',
        position : "fixed",
        top: 0,
        right: 0, 
        bottom: 0, 
        left: 0,
        zIndex: "-1",

    },
    forogtPasswordButtonStyles: {
        position: "relative",
        bottom: "0px",

        display: "block",
        margin: "auto",
        width: "300px",
        marginTop: "20px",
        marginBottom: "50px",
        color: "black",
    },
    loginButtonStyle: {
        borderRadius: 11,
        border: 0,
        marginTop: 20,
        color: 'white',
        backgroundColor: '#66BB6A',

        '&:hover': {
            backgroundColor: '#409144',
        }
    },
    createAccountButtonStyle: {
        borderRadius: 11,
        border: 0,
        marginTop: 20,
        color: 'white',
        backgroundColor: theme.palette.action.main,

        '&:hover': {
            backgroundColor: 'rgb(40, 40, 40)',
        }
    },
    textFieldStyle: {
        marginTop: '60px',
    },
    captionTypographyStyle:{
        textAlign: 'center',
    },
    sideTypographyStyle: {
        textAlign: 'center',
        color: 'white',
        position: "absolute",
        top: "60%", 
        left: "0",
        right: "0",
    },
    sidecCaptionTypographyStyle: {
        textAlign: 'center',
        color: 'rgb(180, 180, 180)',
        position: "absolute",
        top: "65%", 
        left: "0",
        right: "0",
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginLeft: -12,
        marginTop: -5,
    },
  });

  const Login = ({ classes, theme, loading, userNameTextChanged, passwordTextChanged, didPressEnter, showforgotPasswordDialog, navCreateAccount, signIn }) => {

    return (
        <div>
            <div className={classes.background} />
            <div className={classes.logoDiv}>
                <div className={classes.logo} />
                <Typography variant="display1" className={classes.sideTypographyStyle}>
                    Realtor Reward$
                </Typography>
                <Typography variant="headline" className={classes.sidecCaptionTypographyStyle}>
                    by Arch Bend
                </Typography>
            </div>
            
            <div className={classes.loginBackground}> 
                <div className={classes.loginDiv}>
                    <Typography variant="display1" >
                        Login
                    </Typography>
                    <form>
                        <TextField id="email" label="Email" className={classes.textFieldStyle} type="username" fullWidth margin="normal" onChange={userNameTextChanged}/>

                        <TextField id="password" label="Password" type="password" autoComplete="current-password" fullWidth margin="normal" onChange={passwordTextChanged} onKeyPress={didPressEnter}/>
                    </form>
                    <div className={classes.wrapper}>
                        <Button variant='raised' className={classes.loginButtonStyle} color="primary" fullWidth onClick={signIn} disabled={loading} >
                            Login
                        </Button>
                        {loading && <CircularProgress size={30} className={classes.buttonProgress} />}
                    </div>
                    <div className={classes.wrapper}>
                        <Button variant='raised' className={classes.createAccountButtonStyle} fullWidth onClick={navCreateAccount} >
                            Create Account
                        </Button>
                    </div>
                </div>

                <div>
                    <Button color="primary" className={classes.forogtPasswordButtonStyles} onClick={showforgotPasswordDialog} >
                        Forgot Password?
                    </Button>
                </div>
                <Typography variant="caption" className={classes.captionTypographyStyle}>
                    Copyright © 2019 Arch Bend Company. All rights reserved.
                </Typography>
            </div>
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js